import React, { useEffect } from 'react';
import styled from 'styled-components';
import MagicModuleSwitcher from '@modules/MagicModuleSwitcher';
import { Page } from '@style/Shared';
import { Colors, presetColors } from '@client/style/Variables';
import ContentPageStore from '@client/store/ContentPageStore';
import Menu from '@client/modules/Menu/Menu';
import GotoElement from '@client/core/utils/GotoElement';
import SimpleFooter from '@client/modules/Footers/SimpleFooter';
import ContentpageHeader from '@client/modules/ContentpageHeader/ContentpageHeader';
import FilterStore from '@client/modules/ListModules/FilterStore';
import { DateUtils } from '@client/core/utils/DateUtils';
import Site from '@client/store/Site';
import PageOverlay from '@client/modules/overlays/PageOverlays/PageOverlay';
import { findContrastingColor } from '@client/core/utils/colors';

const StyledPage = styled(Page)`
	min-height: 100vh;
`;

export default function ContentPage(props: { content?: any }) {
	const global = Site.use(state => state.global) as any;

	useEffect(() => {
		FilterStore.setTagFilters(props.content._oddTags);
		FilterStore.setLocationFilters(props.content._locationTags);
		FilterStore.setDateFilters(DateUtils.getDaysListFromTo(new Date(global.startDate), new Date(global.endDate)));

		if (props.content?.backgroundColor === null) ContentPageStore.setBackgroundColor(Colors.lightBackground);
		// else ContentPageStore.setBackgroundColor(props.content?.backgroundColor);
	}, []);

	return (
		<StyledPage>
			<Menu
				onLogoClick={() => GotoElement.Instance.scrollToElementWithId(`module_${props.content.startId}`)}
				specificColor={
					props.content?.backgroundColor?.color &&
					findContrastingColor(props.content.backgroundColor?.color, presetColors.white, presetColors.blackish)
				}
			/>
			<PageOverlay></PageOverlay>
			<ContentpageHeader
				title={props.content?.title}
				subtitle={props.content?.subtitle}
				parent={props.content?.parentPage}
				bgColor={props.content?.backgroundColor}
				CTALink={props.content?.link}
				video={props.content?.video}
				fullBleed={props.content?.fullBleed}
				image={props.content?.image}
				indexMenu={props.content?.indexMenu}
				hideBreaker={!props.content?.modules?.length || props.content?.modules[0]?.modelId === 'fullBleedMediaModule'}
			></ContentpageHeader>
			<MagicModuleSwitcher
				modules={props.content ? props.content.modules : []}
				addedNews={props.content ? props.content?._news : undefined}
			/>
			<SimpleFooter optional={props.content.someFooter} />
		</StyledPage>
	);
}
